let url = 'https://basic.home-music.cn';

module.exports = {
  url
}